import * as Sentry from "@sentry/react";
import { ParagraphNode, TextNode } from "lexical";
import { BeautifulMentionNode } from "lexical-beautiful-mentions";

import { beautifulMentionsTheme, lexicalTheme } from "../styling";

const theme = { ...lexicalTheme, ...beautifulMentionsTheme };

export function getConfig() {
  return {
    namespace: "Lexical Editor",
    nodes: [ParagraphNode, TextNode, BeautifulMentionNode],
    onError(error: Error) {
      Sentry.captureMessage(error.message, "warning");
    },
    theme,
  };
}
